export default function nameToId(name) {
  return name.replace(/\W+/g, '_').replace(/^_+/, '').replace(/_+$/, '');
}
